// actions/chat/lexCB.js

import PubSub         from 'pubsub-js';
import { attachAuth } from '../../utils/authService';

// --- ALL ---

export function lexCBHasErrored(bool) {
  return {
    type: 'lexCB_HAS_ERRORED',
    hasErrored: bool
  };
}

export function lexCBIsLoading(bool) {
  return {
    type: 'lexCB_IS_LOADING',
    isLoading: bool
  };
}

export function lexCBFetchDataSuccess(response) {
  return {
    type: 'lexCB_FETCH_DATA_SUCCESS',
    response
  };
}

export function lexCBFetchData(host, msg) {
  return (dispatch) => {
    dispatch(lexCBIsLoading(true));
    dispatch(lexCBHasErrored(false));
    fetch(host + 'catalog/lexCB', {
      method: 'post',
      body: JSON.stringify(msg),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        
        }
        promise.json()
          .then(result => {
            dispatch(lexCBFetchDataSuccess(result));
            dispatch(lexCBHasErrored(false));
            dispatch(lexCBIsLoading(false));
            PubSub.publish('lexCB.response', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(lexCBHasErrored(true));
            dispatch(lexCBIsLoading(false));
            PubSub.publish('lexCB.response', 'An error occurred');
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(lexCBHasErrored(true));
      dispatch(lexCBIsLoading(false));
    });
  };
}